<div class="service-page">
  <header>
    <h1>
      {{ 'service-page.peb-chauffage.title' | translate }}
    </h1>
    <picture class="service-page-banner">
      <img src="../../../assets/images/service-page-peb-chauffage.jpg" alt=""
    /></picture>
  </header>
  <div class="content">
    <h2>
      {{ 'service-page.peb-chauffage.intro' | translate }}
    </h2>
    <div [innerHTML]="'service-page.peb-chauffage.content' | translate"></div>

    <!-- <a class="btn btn-big btn-accent" [routerLink]="['/']" [queryParams]="{ r: 1, e: 4, p: 4 }">
      {{ 'service-page.peb-chauffage.action' | translate }}
    </a> -->
  </div>
</div>
